
export const suppressResizeObserverErrors = () => {
  const originalErrorHandler = window.onerror;

  window.onerror = function (message, source, lineno, colno, error) {
    if (
      message?.includes('ResizeObserver') ||
      message?.includes('ResizeObserver loop') ||
      message?.includes('ResizeObserver loop completed with undelivered notifications')
    ) {
      console.warn('ResizeObserver error suppressed:', message);
      return true;
    }

    if (originalErrorHandler) {
      return originalErrorHandler(message, source, lineno, colno, error);
    }

    return false;
  };

  window.addEventListener('unhandledrejection', function (event) {
    if (
      event.reason?.message?.includes('ResizeObserver') ||
      event.reason?.toString()?.includes('ResizeObserver')
    ) {
      console.warn('ResizeObserver promise rejection suppressed:', event.reason);
      event.preventDefault();
    }
  });
};

export const createDebouncedResizeObserver = (callback, delay = 100) => {
  let timeoutId;
  
  return new ResizeObserver((entries, observer) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      callback(entries, observer);
    }, delay);
  });
};

export const createSafeResizeObserver = (callback) => {
  try {
    return new ResizeObserver((entries, observer) => {
      try {
        requestAnimationFrame(() => {
          callback(entries, observer);
        });
      } catch (error) {
        if (!error.message.includes('ResizeObserver')) {
          console.error('ResizeObserver callback error:', error);
        }
      }
    });
  } catch (error) {
    console.error('Failed to create ResizeObserver:', error);
    return null;
  }
};

export const cleanupStaleCartData = (userId) => {
  try {
    const cartKey = userId ? `cart_${userId}` : 'cart_guest';
    const storedCart = localStorage.getItem(cartKey);
    
    if (storedCart) {
      const cart = JSON.parse(storedCart);
      
      // Validate cart structure and clean up invalid entries
      const cleanedCart = Object.entries(cart).reduce((acc, [storeName, items]) => {
        const validItems = items.filter(item => {
          // Check if item has required properties (minimal cart shape: { listing_id, quantity })
          return (
            item &&
            item?.listing_id != null &&
            item?.quantity > 0
          );
        });
        
        if (validItems.length > 0) {
          acc[storeName] = validItems;
        }
        
        return acc;
      }, {});
      
      localStorage.setItem(cartKey, JSON.stringify(cleanedCart));
      
      return cleanedCart;
    }
  } catch (error) {
    console.error('Failed to clean up cart data:', error);
  }
  
  return {};
};

export const getSafeSeller = (seller) => {
  if (!seller) {
    return {
      id: null,
      store_name: 'Unknown Seller',
      first_name: '',
      last_name: '',
      full_name: 'Unknown Seller',
      city: '',
      phone_number: '',
      store_logo: null,
    };
  }

  return {
    id: seller.id || null,
    store_name: seller.store_name || 'Unknown Seller',
    first_name: seller.first_name || '',
    last_name: seller.last_name || '',
    full_name: seller.full_name || seller.store_name || 'Unknown Seller',
    city: seller.city || '',
    phone_number: seller.phone_number || '',
    store_logo: seller.store_logo || null,
  };
};

export const getSellerName = (seller) => {
  if (!seller) return 'Unknown Seller';
  
  if (typeof seller === 'string') return seller;
  
  return (
    seller.store_name ||
    seller.full_name ||
    `${seller.first_name || ''} ${seller.last_name || ''}`.trim() ||
    `Seller ${seller.id || 'Unknown'}` ||
    'Unknown Seller'
  );
};

